export default "__VITE_ASSET__38c816b3__"